"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./ArrowButtons.module.css";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { useContext } from "react";
import { CarouselContext } from "../CarouselContext";
export function ArrowButtons() {
  const $ = _c(13);
  const {
    goToPrevious,
    goToNext,
    hasPrevious,
    hasNext
  } = useContext(CarouselContext);
  const t0 = !hasPrevious;
  const t1 = !hasPrevious;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowLeftIcon />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== goToPrevious || $[2] !== t0 || $[3] !== t1) {
    t3 = <div role="button" aria-label="Previous slide" className={styles.arrowButton} onClick={goToPrevious} data-disabled={t0} aria-disabled={t1}>{t2}</div>;
    $[1] = goToPrevious;
    $[2] = t0;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !hasNext;
  const t5 = !hasNext;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowRightIcon />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== goToNext || $[7] !== t4 || $[8] !== t5) {
    t7 = <div role="button" aria-label="Next slide" className={styles.arrowButton} onClick={goToNext} data-disabled={t4} aria-disabled={t5}>{t6}</div>;
    $[6] = goToNext;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7) {
    t8 = <div className={styles.arrowButtons}>{t3}{t7}</div>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}